import { useMutation, useQueryClient } from '@tanstack/react-query';

import { organisationApi } from '../../apis/organisation';
import { organisationsQueries } from '../../queries/organisations';

import { useQueriesWithGlobal } from '@data-access';

export function useDeleteOrganisation() {
  const client = useQueryClient();
  const queries = useQueriesWithGlobal(organisationsQueries);

  const mutation = useMutation({
    mutationFn: organisationApi.deleteOne,
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: queries.all(),
      });
    },
  });

  return mutation;
}

export default useDeleteOrganisation;
